/**
 * @overview token业务处理
 */

const get = () => localStorage.getItem('token');

const remove = () => {
  localStorage.removeItem('token');
};

const set = (token) => {
  localStorage.setItem('token', token);
};
const getCookie = (name) =>{
  var strcookie = document.cookie;//获取cookie字符串
  var arrcookie = strcookie.split("; ");//分割
  //遍历匹配
  for ( var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] === name){
      return arr[1];
    }
  }
  return "";
};

export default {
  remove,
  set,
  get,
  getCookie,
};



// WEBPACK FOOTER //
// ./src/utils/token.js